export * from './vendas'
